exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".header---3NjFG {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between;\n  background-color: #dbe3e9;\n  height: 60px; }\n  .header---3NjFG h1 {\n    font-size: 20px;\n    font-size: 1.25rem; }\n  .header---3NjFG [class*=\"TitleContainer\"] {\n    padding: 0 20px; }\n  .header---3NjFG [class*=\"SubHeader\"] {\n    background-color: #dbe3e9;\n    padding: 0 10px 0 0; }\n  .buttonsContainer---2nLON {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  height: 100%; }\n", ""]);

// exports
exports.locals = {
	"header": "header---3NjFG",
	"buttonsContainer": "buttonsContainer---2nLON"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./components/app-heading/app-heading.scss
// module id = mPf8
// module chunks = 1